import ReactGA from "react-ga";


export const initGA = (id) => {           
    ReactGA.initialize(id); 
 }

 export const PageView = () => {  
    ReactGA.pageview(window.location.pathname +  
                     window.location.search); 
                     console.log("pageview call");
}

export const Event = (category, action, label) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label
    });
    console.log("event call");
  };